module.exports = __webpack_public_path__ + "static/img/chery_zhutu@2x.fe30e65.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/homepage/chery_zhutu@2x.png
// module id = wLFl
// module chunks = 0